export const MUST_LOGIN_MESSAGE =
  "Veuillez vous connecter pour pouvoir continuer la navigation.";
export const LOGOUT_SUCCESSED_MESSAGE = "Vous avez été déconnecté avec succès.";
export const LOGIN_SUCCESSED_MESSAGE = "Vous êtes connecté.";
export const LOGIN_ERROR_MESSAGE =
  "L'utilisateur ou le mot de passe sont incorrect.";
